export const SubscriptionStatusTranslationMap = Object.freeze({
  processing: 'shared.status.subscription.processing',
  authorized: 'shared.status.subscription.authorized',
  canceled: 'shared.status.subscription.canceled',
  ended: 'shared.status.subscription.ended',
  refunded: 'shared.status.subscription.refunded',
  waiting_payment: 'shared.status.subscription.waiting_payment',
  pending_payment: 'shared.status.subscription.pending_payment',
  refund_pending: 'shared.status.subscription.refund_pending',
  pending_refund: 'shared.status.subscription.pending_refund',
  refused: 'shared.status.subscription.refused',
  chargedback: 'shared.status.subscription.chargedback',
  delayed: 'shared.status.subscription.delayed',
  trialing: 'shared.status.subscription.trialing',
  unpaid: 'shared.status.subscription.unpaid',
  paid: 'shared.status.subscription.paid'
});
